import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/utils/tailwind.ts";

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention,@typescript-eslint/consistent-type-definitions
  interface Window {
    adsbygoogle: unknown[];
  }
}

type SvAdSectionProps = {
  className: string;
};

export const SvAdSection = ({ className }: SvAdSectionProps) => {
  const [isInstanceLoaded, setInstanceLoaded] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    try {
      if (window.adsbygoogle && !isInstanceLoaded) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        setInstanceLoaded(true);
      }
    } catch (e) {
      console.error(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <fieldset
      className={cn(
        "border-ind-grey-50 rounded-2xl border p-6 has-[>ins[data-ad-status='unfilled']]:hidden",
        className,
      )}>
      <legend>{t("ads.title")}</legend>
      <ins
        className="adsbygoogle block h-full w-full rounded-md bg-neutral-200 text-center data-[ad-status=filled]:bg-transparent"
        data-ad-client="ca-pub-5161407275367789"
        data-ad-slot="7936984745"
        data-ad-format="auto"
        data-full-width-responsive="true"></ins>
    </fieldset>
  );
};
